import { Component } from '@angular/core';
import { AppSettingService } from 'src/app/services/app-setting.service';

@Component({
  selector: 'app-inventory-pivot-organism',
  templateUrl: './inventory-pivot-organism.component.html',
  styleUrls: ['./inventory-pivot-organism.component.scss']
})
export class InventoryPivotOrganismComponent {
  settings: any;
  dashboardConfigs: any[] = [];
  defaultDashboard = [{
    "title": "Stock by Category",
    "config": {
      "rowCollection": "material",
      "rowField": "category_level2",
      "columnCollection": "stock",
      "columnField": "location",
      "rowFilters": []
    }
  }];

  constructor(private settingService: AppSettingService) { }

  ngOnInit(): void {
    this.settings = this.settingService.getSettings();
    if (this.settings['inventory_dashboard']) {
      this.dashboardConfigs = this.settings['inventory_dashboard'];
    } else {
      this.dashboardConfigs = this.defaultDashboard;
    }
  }


}
